/**
 * Root Reducer
 */
import { combineReducers } from 'redux';

// Import Reducers
import app from './modules/App/AppReducer';
import intl from './modules/Intl/IntlReducer';
import error from './modules/Error/ErrorReducer';
import config from './modules/Config/ConfigReducer';
import cms from './modules/Cms/CmsReducer';
import currency from './modules/Currency/CurrencyReducer';

import addresses from './modules/Address/AddressReducer';
import cart from './modules/Cart/CartReducer';
import orders from './modules/Order/OrderReducer';
import subscriptions from './modules/Subscription/SubscriptionReducer';
import reviews from './modules/Review/ReviewReducer';
import products from './modules/Product/ProductReducer';
import shippingFees from './modules/ShippingFee/ShippingFeeReducer';
import taxes from './modules/Tax/TaxReducer';
import users from './modules/User/UserReducer';
import vouchers from './modules/Voucher/VoucherReducer';

// Combine all reducers into one root reducer
export default combineReducers({
    addresses,
    app,
    cart,
    cms,
    config,
    currency,
    error,
    intl,
    orders,
    products,
    reviews,
    shippingFees,
    subscriptions,
    taxes,
    users,
    vouchers,
});
